import { action, observable, computed } from 'mobx';
import { AccelFile, CourseItemTestAnswer, Entity } from '../../../../';

export default class CourseItemTestQuestion extends Entity {
    constructor(question?: Partial<CourseItemTestQuestion>) {
        super(question);
        if (question) this.update(question);
    }
    @observable question: string;
    @observable position: number;
    @observable score: number;
    @observable multiAnswer: boolean;
    @observable answers: CourseItemTestAnswer[];
    @observable file: AccelFile | null;
    @observable shuffle: boolean;

    @computed get correctAnswers() {
        return this.answers.filter(x => x.isCorrect == true);
    }

    @computed get hasCorrectAnswer() {
        return this.answers.some(x => x.isCorrect == true);
    }

    @action
    update(question: Partial<CourseItemTestQuestion>, allowUndefined = false) {
        super.update(question, allowUndefined);
    }

    clone(changes?: Partial<CourseItemTestQuestion>): CourseItemTestQuestion {
        return new CourseItemTestQuestion({
            ...this,
            answers: this.answers?.map(x => x.clone()) ?? [],
            file: this.file ? this.file.clone() : null,
            ...changes
        });
    }

    static fromJson(json: any): CourseItemTestQuestion {
        return new CourseItemTestQuestion({
            ...json,
            file: json.file ? AccelFile.fromJson(json.file) : null,
            answers: json.answers ? json.answers.map((x: any) => new CourseItemTestAnswer(x)) : undefined
        });
    }
}